export const PORTFOLIO_TABS = [
  { key: "introduce", label: "미러포트폴리오" },
  { key: "top10", label: "Top10종목" },
  { key: "newbuy", label: "신규매수종목" },
  { key: "addbuy", label: "추가매수종목" },
  { key: "sell", label: "매도종목" },
];

export function getPortfolioStatusBadge(status) {
  if (status === "매도") return "bg-danger-subtle text-danger";
  if (status === "추매") return "bg-primary-subtle text-primary";
  return "bg-info-subtle text-info";
}